import { Controller } from 'stimulus';
import Vue from 'vue';
import Intake from '@/intake/Intake.vue';
import store from '@/intake/stores';

class IntakeController extends Controller {
  connect() {
    const { element } = this;

    // eslint-disable-next-line no-new
    new Vue({
      el: this.appTarget,

      store,

      components: {
        Intake,
      },

      created() {
        this.$store.commit('hydrate', element.dataset);
        this.$store.commit('address/hydrate', element.dataset);
        this.$store.commit('room/hydrate', element.dataset);
      },
    });
  }
}

IntakeController.targets = [
  'app',
];

export default IntakeController;
